// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"415aac5a","453":"97312a57","487":"609d05e8","591":"49d19149","680":"8de8ecd5"}[chunkId] + ".chunk.js";
};